import { createRouter, createWebHistory } from 'vue-router'
import { getSessionId }                    from '../services/index.js'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/',          redirect: '/dashboard' },
    { path: '/login',     name: 'Login',     component: () => import('../views/LoginView.vue'),     meta: { guest: true } },
    { path: '/dashboard', name: 'Dashboard', component: () => import('../views/DashboardView.vue'), meta: { auth: true  } },
  ],
})

router.beforeEach((to) => {
  const loggedIn = !!getSessionId()
  if (to.meta.auth  && !loggedIn) return { name: 'Login' }
  if (to.meta.guest &&  loggedIn) return { name: 'Dashboard' }
})

export default router
